module.exports = __webpack_public_path__ + "static/media/time-save-icon.c9632956.svg";